import { EARNED_SEARCHES_FILTERS_OPERATORS } from 'constants/constants';
import {
  JOB_POSTINGS,
  MARKET_RESEARCH_REPORTS,
} from 'pages/EarnedSearch/FiltersLocalSources/contentType';

export const calculateSelectionRate = (
  selectedItemsLength,
  fullCollectionLength,
) => (selectedItemsLength * 100) / fullCollectionLength;

const standard = (selectionRate, selected, unselected) => {
  if (selectionRate === 100) {
    return {
      operator: EARNED_SEARCHES_FILTERS_OPERATORS.is,
      values: selected.concat(unselected),
    };
  } else if (selectionRate === 0) {
    return {
      operator: EARNED_SEARCHES_FILTERS_OPERATORS.is,
      values: [],
    };
  } else if (selectionRate > 50) {
    return {
      operator: EARNED_SEARCHES_FILTERS_OPERATORS.not,
      values: unselected,
    };
  } else {
    return {
      operator: EARNED_SEARCHES_FILTERS_OPERATORS.is,
      values: selected,
    };
  }
};

const inclusiveOnly = (selectionRate, selected, unselected) => ({
  operator: EARNED_SEARCHES_FILTERS_OPERATORS.is,
  values: selected,
});

export const ToggleFilterCriteria = {
  standard,
  inclusiveOnly,
};

const standardCurrentItemsCriteria = (
  currentItems,
  selectedKeys,
  unselectedKeys,
) => {
  let targetCollectionKey = selectedKeys;
  let fallbackCollectionKey = unselectedKeys;
  if (currentItems.operator === EARNED_SEARCHES_FILTERS_OPERATORS.not) {
    targetCollectionKey = unselectedKeys;
    fallbackCollectionKey = selectedKeys;
  }
  return { targetCollectionKey, fallbackCollectionKey };
};

const contentTypeDisabledItemCriteria = (
  itemData,
  isQualityFilterEnabled,
): boolean =>
  isQualityFilterEnabled &&
  (itemData.value === JOB_POSTINGS ||
    itemData.value === MARKET_RESEARCH_REPORTS);

export const CurrentItemsCriteria = {
  standard: standardCurrentItemsCriteria,
};

export const DisabledItemsCriteria = {
  contentType: contentTypeDisabledItemCriteria,
};
